// extracted by mini-css-extract-plugin
export var menuItem = "F_v5 d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "F_v6 d_Z d_bz d_bP";
export var menuMainLink = "F_v7 d_f0 d_dB";
export var menuLink = "F_v8 d_f0 d_dB";
export var icon = "F_p9 d_bC d_bP";
export var divider = "F_v9 d_bC d_bP";
export var sublinks = "F_wb";
export var link = "F_mC";
export var Link = "F_vH D_vH D_t1 D_vl";